/**
 * Implements a three-column layout
 */
import { useSelector } from 'react-redux';
import ChartResizer from '../../components/ChartResizer';
import DexTrades from '../../components/DexTrades';
import Info from '../../components/Info';
import Resizer from '../../components/Modal/TickersModal/TickersPanel/Resizer';
import Trading from '../../components/Trading';
import Watchlist from '../../components/Watchlist';
import AlertsView from '../../components/Watchlist/AlertsView';
import { IStore } from '../../reducers';
import ChartDisplay from './ChartDisplay';
import { LS_TRADING_HEIGHT } from '../../components/Trading';

import './styles.scss';

interface IBody {
  isWatchlistVisible: boolean;
  isChartVisible: boolean;
  isTradesVisible: boolean;
  isTradingVisible: boolean;
  isInfoVisible: boolean;
  onChange: (key: string, value: boolean) => void;
}

export const LS_CHART_BASIS_SIZES = 'kattana-simple.chart-dextrades';
const stringifiedDefaultBasisState = '{"flex1":67,"flex2":33}';

const basisesLC = JSON.parse(
  localStorage.getItem(LS_CHART_BASIS_SIZES) || stringifiedDefaultBasisState
);

const Body = (props: IBody) => {
  const chartPickerSelected = useSelector(
    (state: IStore) => state.chartPicker.selected
  );

  return (
    <div className='body'>
      <div className='left_block'>
        <div className='row' style={{ flexBasis: `${basisesLC.flex1}%` }}>
          <Watchlist visible={props.isWatchlistVisible} />
          {!props.isWatchlistVisible && <AlertsView />}
          {props.isChartVisible && (
            <ChartDisplay isMobile={false} selected={chartPickerSelected} />
          )}
        </div>
        {props.isChartVisible && props.isTradesVisible && <ChartResizer />}
        <div
          className={`row ${props.isTradesVisible ? '' : 'hide'}`}
          style={{ flexBasis: `${basisesLC.flex2}%` }}
        >
          {props.isTradesVisible && <DexTrades />}
        </div>
      </div>
      <div
        className={`right_block ${
          !props.isTradingVisible && !props.isInfoVisible ? 'hide' : ''
        }`}
      >
        {props.isTradingVisible && <Trading />}
        {props.isTradingVisible && props.isInfoVisible && (
          <Resizer
            targetClass='trading'
            storageKey={LS_TRADING_HEIGHT}
            bottomGap={100}
            topGap={100}
            styleProperty='flexBasis'
          />
        )}
        {props.isInfoVisible && <Info />}
      </div>
    </div>
  );
};

export default Body;
